<div class="container-fluid" *ngIf="pageSchema">
  <h1>
    Samplicity Platform
  </h1>
  <p>Samplicity Platform Landing Page</p>
</div>
<samplicity-footer></samplicity-footer>
